import React from "react";
import { connect } from "react-redux";

import * as sessionActions from "../modules/session";

import { alertError, alertSuccess } from "Utils/alerts";
import t from "Utils/translation";

import request from "../config";

import Button from "Components/button/Button";
import Input from "Components/input/Input";
import Loader from "Components/loader/Loader";
import TranslatedString from "Components/TranslatedString";
import withFormState from "Components/withFormState";

import s from "./resetPasswordPage.scss";

import qs from "query-string";

class ResetPasswordPage extends React.Component {
  state = {
    languageSelectValue: { value: "it", label: "italian" },
  };

  componentDidMount() {
    // verify validity of change password token

    this.props.verifyToken("/users/signup?t=" + qs.parse(this.props.location.search).t);
  }

  componentDidUpdate() {
    if (this.props.verification.tokenIvalid === true) {
      this.props.history.push("/login");
    }
  }

  setSelectValue = (val) => {
    this.setState({ languageSelectValue: val });
  };

  onSuccess = () => {
    alertSuccess(t("alert.registration.completed"));
    location.reload();
  };

  isDelegate = () => {
    return this.props.match.params.userCode.slice(0, 2) === "DL";
  };

  validate = ({ password, password_confirmation }) => {
    let errors = {};
    if (password.length < 8) errors.password = "is too short";
    if (password !== password_confirmation) errors.password_confirmation = "is too short";
    return errors;
  };

  setPassword = (e) => {
    e.preventDefault();
    const query = qs.parse(this.props.location.search);

    this.props.setFormLoading();
    const errors = this.validate(this.props.formData);
    if (Object.keys(errors) > 0) {
      this.props.setFormErrors(errors);
      this.props.unsetFormLoading();
    } else {
      let url = "/users/" + this.props.match.params.userCode + "/reset_password?t=" + query.t;

      if (query.new_user) {
        url += "&new_user=true";
      }

      const config = {
        method: "PUT",
        url: url,
        data: this.props.formData,
      };
      request(config)
        .then(() => {
          this.props.unsetFormLoading();
          alertSuccess(t("alert.registration.completed"));
          if (this.isDelegate()) {
            window.location.href = BASE_URL_VAULT;
          } else {
            location.reload();
          }
        })
        .catch((e) => {
          if (e.response.status === 422) {
            alertError(t("alert.error.validation"));
            this.props.setFormErrors({
              password: t("errorMsg.length.passowrd"),
            });
            this.props.unsetFormLoading();
          }

          if (e instanceof Error) throw e;
        });
    }
  };

  render() {
    let content;

    if (this.props.verification.loading == true) {
      content = (
        <div className={s.resetPasswordPage}>
          <Loader msg={t("loading.msg.token")} />
        </div>
      );
    } else {
      content = (
        <div className={s.resetPasswordPage}>
          <form className={s.form} method="post" onSubmit={this.setPassword}>
            <h1 className={s.title}>{t("reset.password.title")}</h1>
            <p className={s.text}>
              <TranslatedString>reset.password.desc</TranslatedString>
            </p>

            <Input
              className={s.input}
              name="password"
              label={t("input.label.password")}
              type="password"
              value={this.props.formData.password}
              errors={this.props.formErrors.password}
              onChange={this.props.setFormFieldValue}
              required
              showPasswordScore
            />

            <Input
              className={s.input}
              name="password_confirmation"
              label={t("input.label.passwordConfirm")}
              type="password"
              value={this.props.formData.password_confirmation}
              errors={this.props.formErrors.password_confirmation}
              onChange={this.props.setFormFieldValue}
              required
            />

            <footer className={s.footer}>
              <Button type="submit" loading={this.props.isFormLoading}>
                button.passwordSet
              </Button>
            </footer>
          </form>
        </div>
      );
    }

    return content;
  }
}

const mapStateToProps = (state) => {
  return {
    verification: state.session.registration.verification,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    verifyToken: (url) => {
      dispatch(sessionActions.getFromServer(url, "VERIFY_TOKEN"));
    },
  };
};

export default withFormState(connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage), {
  password: "",
  password_confirmation: "",
});
